import {
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  plus20p0vtfmu0596 as plus,
  dropLast1vpiyky649o34 as dropLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CanBlockBacknswc7za76703 as CanBlockBack } from './CanBlockBack.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { askForConfirmNavigateAway3jun0podjheub as askForConfirmNavigateAway } from './Navigator.js.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { lazyContextAddon10t74vogc7n59 as lazyContextAddon } from '../views/ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_pageNavigator(_this__u8e3s4, _set____db54di) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_pageNavigator_$ref_twffzs();
  return pageNavigator$delegate.setValue_jr48c5_k$(_this__u8e3s4, getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0()), _set____db54di);
}
function get_pageNavigator(_this__u8e3s4) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_pageNavigator_$ref_twffzs();
  return pageNavigator$delegate.getValue_o7pe7q_k$(_this__u8e3s4, getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0()));
}
var pageNavigator$delegate;
function _get_allowNavigate__ncx9vb($this) {
  var tmp = lastOrNull($this.stack_1.get_value_j01efc_k$());
  var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, CanBlockBack()) : false) ? tmp : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.onNavigateAwayAttempt_vrrtsh_k$();
  var notBlocked = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  return notBlocked ? true : askForConfirmNavigateAway($this);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function PageNavigator$_get_routes_$ref_f110b8() {
  return constructCallableReference((p0) => p0.get_routes_j3zccz_k$(), 1, 0, 95);
}
var PageNavigatorClass;
function PageNavigator() {
  if (PageNavigatorClass === VOID) {
    class $ {
      constructor(routesGetter) {
        this.routesGetter_1 = routesGetter;
        var tmp = this;
        tmp.routes$delegate_1 = lazy(() => this.routesGetter_1());
        var tmp_0 = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_0.stack_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(tmp$ret$0);
        var tmp_1 = this;
        tmp_1.currentPage_1 = remember(VOID, VOID, VOID, 8, ($this$remember) => lastOrNull($this$remember.invoke_r7m7el_k$(this.stack_1)));
        var tmp_2 = this;
        tmp_2.canGoBack_1 = remember(VOID, VOID, VOID, 8, ($this$remember) => $this$remember.invoke_r7m7el_k$(this.stack_1).get_size_woubt6_k$() > 1);
      }
      get_routes_j3zccz_k$() {
        var tmp0 = this.routes$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('routes', 1, tmp, PageNavigator$_get_routes_$ref_f110b8(), null);
        return tmp0.get_value_j01efc_k$();
      }
      navigate_sm5lxf_k$(screen) {
        if (_get_allowNavigate__ncx9vb(this)) {
          var _receiver__tnumb7 = this.stack_1;
          _receiver__tnumb7.set_value_v1vabv_k$(plus(_receiver__tnumb7.get_value_j01efc_k$(), screen));
        }
      }
      replace_7qh33u_k$(screen) {
        if (_get_allowNavigate__ncx9vb(this)) {
          this.stack_1.set_value_v1vabv_k$(plus(dropLast(this.stack_1.get_value_j01efc_k$(), 1), screen));
        }
      }
      reset_diztr_k$(screen) {
        if (_get_allowNavigate__ncx9vb(this)) {
          this.stack_1.set_value_v1vabv_k$(listOf(screen));
        }
      }
      goBack_kj7lzl_k$() {
        if (this.stack_1.get_value_j01efc_k$().get_size_woubt6_k$() <= 1 || !_get_allowNavigate__ncx9vb(this)) {
          return false;
        }
        this.stack_1.set_value_v1vabv_k$(dropLast(this.stack_1.get_value_j01efc_k$(), 1));
        return true;
      }
    }
    initMetadataForClass($, 'PageNavigator');
    PageNavigatorClass = $;
  }
  return PageNavigatorClass;
}
function pageNavigator$delegate$lambda(it) {
  _init_properties_Navigator_kt__ww6let();
  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$("'ElementContext.pageNavigator' has not been initialized. It is recommended to call 'appBase { ... }' at the root of your app to properly initialize pageNavigator, as well as many other properties.");
}
function _get_pageNavigator_$ref_twffzs() {
  return constructCallableReference((p0) => get_pageNavigator(p0), 1, 0, 96);
}
function _set_pageNavigator_$ref_jevpp0() {
  return constructCallableReference((p0, p1) => {
    set_pageNavigator(p0, p1);
    return Unit_instance;
  }, 2, 0, 97);
}
var properties_initialized_Navigator_kt_hi8lg9;
function _init_properties_Navigator_kt__ww6let() {
  if (!properties_initialized_Navigator_kt_hi8lg9) {
    properties_initialized_Navigator_kt_hi8lg9 = true;
    pageNavigator$delegate = lazyContextAddon(pageNavigator$delegate$lambda);
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PageNavigator as PageNavigator20tezdf2xr1uc,
  get_pageNavigator as get_pageNavigatorp3to6r4j8ctv,
  set_pageNavigator as set_pageNavigator2tlfgk6pqrj4q,
  _get_pageNavigator_$ref_twffzs as _get_pageNavigator_$ref_twffzs1y4q72w3j5wfo,
  _set_pageNavigator_$ref_jevpp0 as _set_pageNavigator_$ref_jevpp01gsvioa3u4qpr,
};
//endregion

//# sourceMappingURL=Navigator.mjs.map
